import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function usePixPayment() {
    const navigate = useNavigate();
    const [isNavigatingToPix, setIsNavigatingToPix] = useState(false);
    const [error, setError] = useState(null);
    const navigateToPixFlow = (rechargeId) => {
        try {
            setIsNavigatingToPix(true);
            setError(null);
            navigate(`/beneficios/recarga/${rechargeId}/pagar/bolepix`, {
                state: {
                    rechargeId,
                },
            });
        }
        catch (err) {
            setError('Error navigating to PIX flow');
            setIsNavigatingToPix(false);
        }
    };
    return {
        isNavigatingToPix,
        navigateToPixFlow,
        error,
    };
}
